import React from "react";
import RichNotebookEditor from "../RichNotebookEditor";

const NotebookEditor = ({
    notes,
    handlePageContentChange,
    isExpanded,
}) => {
    return (
        <>
            <div
                className="
                    min-h-0
                    flex-1
                    overflow-auto
                    rounded-2xl
                    [&>div]:flex
                    [&>div]:min-h-full
                    [&>div]:flex-col
                "
            >
                <div
                    className={
                        isExpanded
                            ? "min-h-[950px]"
                            : "min-h-[680px]"
                    }
                >
                    <RichNotebookEditor
                        content={notes}
                        onContentChange={
                            handlePageContentChange
                        }
                    />
                </div>
            </div>

            <p className="shrink-0 px-1 pt-2 text-xs text-[#7f8baa]">
                Select a page from the
                Table of Contents to continue
                its notes.
            </p>
        </>
    );
};

export default NotebookEditor;